import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Account({ v }) {
  if (!v.showAccount) return null;
  return (
    <>
      {' '}
      <div style={css(v.accOverlayStyle)} onClick={v.closeDialog}>
        {' '}
        <div onClick={v.stopProp} style={css(v.accModalStyle)}>
          {' '}
          <div style={css(v.accHeaderStyle)}>
            {' '}
            {v.showProfileBack ? (<>
              {' '}
              <button onClick={v.closeProfile} className="gp-btn" title="Terug naar iedereen" style={{ "flex": "0 0 auto", "gap": "7px", "marginRight": "10px" }}>
                {' '}
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15 18-6-6 6-6" />
                </svg>
                {"\n            Profielen\n          "}
              </button>
              {' '}
            </>) : null}
            {' '}
            {v.showAccountEditor ? (<>
              {' '}
              <button onClick={v.backToAccMenu} className="gp-btn" title="Terug naar de lijst" style={{ "flex": "0 0 auto", "gap": "7px", "marginRight": "10px" }}>
                {' '}
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15 18-6-6 6-6" />
                </svg>
                {"\n            Terug\n          "}
              </button>
              {' '}
            </>) : null}
            {' '}
            <div style={css(v.accTitleStyle)}>
              <Interp v={v.accTitleLabel} />
            </div>
            {' '}
            <button onClick={v.closeDialog} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
            {' '}
          </div>
          {' '}
          <div style={css(v.accBodyStyle)}>
            {' '}
            {v.hasAccountHint ? (<>
              {' '}
              <div style={{ "background": "var(--lila)", "border": "3px solid var(--ink)", "borderRadius": "12px", "padding": "12px 14px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.4" }}>
                <Interp v={v.accountHint} />
              </div>
              {' '}
            </>) : null}
            {' '}
            {v.hasAccountError ? (<>
              {' '}
              <div style={{ "background": "var(--roze-vlak)", "border": "3px solid var(--fout)", "borderRadius": "12px", "padding": "12px 14px", "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.4", "color": "var(--fout)" }}>
                <Interp v={v.accountError} />
              </div>
              {' '}
            </>) : null}
            {' '}
            <div style={css(v.accColsStyle)}>
              {' '}
              {/* Hier stond de knoppenkolom van de oude hal: een menu naar het
                  postvakje, de ideeenbus, het leaderbord, het gastenboek en het
                  modgereedschap, met een tweede kopie van al die schermnamen erin. Het
                  startmenu heeft die taak overgenomen en de vlag stond sindsdien hard
                  op false, dus deze tienduizend tekens werden nooit meer getekend. */}
              {' '}
              {v.showAccountEditor ? (<>
                {' '}
                <div style={css(v.accLeftColStyle)}>
                  {' '}
                  <div>
                    {' '}
                    <div style={css(v.veldKopStyle)}>
                      Naam
                    </div>
                    {' '}
                    <input type="text" value={v.editName ?? ''} onInput={v.onNameInput} placeholder="Bijv. Jan Doodle van Oranje" />
                    {' '}
                  </div>
                  {' '}
                  <div>
                    {' '}
                    <div style={{ "display": "flex", "alignItems": "center", "justifyContent": "space-between", "gap": "8px", "height": "19px", "marginBottom": "5px" }}>
                      <span style={{ "fontSize": "13px", "fontWeight": "600" }}>
                        Status
                      </span>
                      <span style={css(v.bioCountStyle)}>
                        <Interp v={v.bioCountLabel} />
                      </span>
                    </div>
                    {' '}
                    <input type="text" value={v.editBio ?? ''} onInput={v.onBioInput} placeholder="Waar ben je mee bezig?" />
                    {' '}
                  </div>
                  {' '}
                  <div>
                    {' '}
                    <div style={css(v.veldKopStyle)}>
                      Favoriete eten
                    </div>
                    {' '}
                    <input type="text" value={v.editFavFood ?? ''} onInput={v.onFavFoodInput} placeholder="Bijv. spaghetti" />
                    {' '}
                  </div>
                  {' '}
                  {v.showPinButton ? (<>
                    {' '}
                    <div>
                      {' '}
                      <div style={css(v.veldKopStyle)}>
                        Pincode
                      </div>
                      {' '}
                      <button onClick={v.openPinSetter} className="gp-btn" title={v.pinButtonLabel} style={css(v.pinTileStyle)}>
                        {' '}
                        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                          <rect x="3" y="11" width="18" height="11" rx="2" />
                          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                        {' '}
                        <span style={{ "fontSize": "15px", "fontWeight": "600", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                          <Interp v={v.pinBtnShort} />
                        </span>
                        {' '}
                      </button>
                      {' '}
                    </div>
                    {' '}
                  </>) : null}
                  {' '}
                </div>
                {' '}
                <div style={css(v.accEditRightStyle)}>
                  {' '}
                  <div style={{ "display": "flex", "flexDirection": "column" }}>
                    <div style={css(v.veldKopStyle)}>
                      Avatar
                    </div>
                    <div style={css(v.avatarPreviewWrapStyle)}>
                      {' '}
                      {v.hasEditAvatar ? (<>
                        {' '}
                        <img alt="" src={v.editAvatarUrl} style={{ "display": "block", "width": "100%", "height": "100%", "objectFit": "contain", "imageRendering": "pixelated" }} />
                        {' '}
                      </>) : null}
                      {' '}
                      {v.noEditAvatar ? (<>
                        {' '}
                        <span style={{ "fontSize": "13px", "fontWeight": "600", "color": "var(--tekst-3)", "textAlign": "center", "padding": "10px" }}>
                          Nog niets getekend
                        </span>
                        {' '}
                      </>) : null}
                      {' '}
                    </div>
                    <button onClick={v.openAvatarEditor} className="gp-btn" title={v.avatarBtnTitle} style={css(v.avatarBtnStyle)}>
                      Aanpassen
                    </button>
                  </div>
                  {' '}
                </div>
                {' '}
              </>) : null}
              {' '}
              {v.showAccountRight ? (<>
                {' '}
                <div style={css(v.accRightColStyle)}>
                  {' '}
                  {v.showProfileLoading ? (<>
                    <div style={css(v.profileLegeStyle)}>
                      <Interp v={v.profileLoadingText} />
                    </div>
                  </>) : null}
                  {' '}
                  {v.showProfileMissing ? (<>
                    <div style={css(v.profileLegeStyle)}>
                      <Interp v={v.profileMissingText} />
                    </div>
                    <button onClick={v.closeProfile} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
                      Naar iedereen
                    </button>
                  </>) : null}
                  {' '}
                  {v.showProfile ? (<>
                    {' '}
                    <div style={css(v.profileWrapStyle)}>
                      {' '}
                      <div style={{ "display": "flex", "alignItems": "center", "gap": "16px", "flex": "0 0 auto" }}>
                        <img alt="" src={v.profileAvatarUrl} style={{ "width": "92px", "height": "92px", "imageRendering": "pixelated", "border": "4px solid var(--ink)", "borderRadius": "16px", "background": "#fff", "boxShadow": "4px 4px 0 var(--ink)", "display": "block", "flex": "0 0 auto" }} />
                        <div style={{ "minWidth": "0", "display": "flex", "flexDirection": "column", "gap": "5px" }}>
                          <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "minWidth": "0" }}>
                            <div style={{ "fontSize": "26px", "fontWeight": "700", "lineHeight": "1.2", "overflowWrap": "anywhere", "minWidth": "0" }}>
                              <Interp v={v.profileName} />
                            </div>
                            {v.showProfileStreak ? (<>
                              <span title={v.profileStreakTitle} style={{ "display": "flex", "alignItems": "center", "justifyContent": "center", "width": "30px", "height": "30px", "boxSizing": "border-box", "flex": "0 0 auto", "background": "var(--geel-vlak)", "border": "3px solid var(--ink)", "borderRadius": "8px" }}>
                                <svg width="17" height="17" style={{ "display": "block" }} viewBox="0 0 24 24" fill="#ffa300" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M12 2c1.5 3.5-1 5-1 7a3 3 0 0 0 6 0c0-1-.4-2-1-3 3 2 5 5 5 8a8 8 0 0 1-16 0c0-4.5 3-8 7-12Z" />
                                </svg>
                              </span>
                            </>) : null}
                          </div>
                          <div style={{ "display": "flex", "alignItems": "center", "gap": "7px", "fontSize": "13px", "fontWeight": "700", "color": "var(--tekst-2)" }}>
                            <span style={css(v.profileDotStyle)} />
                            <Interp v={v.profileStatus} />
                          </div>
                          <div style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-3)" }}>
                            <Interp v={v.profileSince} />
                          </div>
                        </div>
                      </div>
                      {' '}
                      <div style={css(v.profileBioStyle)}>
                        <Interp v={v.profileBio} />
                      </div>
                      {' '}
                      {/* De krabbels van deze persoon in het klein. Klikken opent
                          hem op de paal. Hier stonden drie cijfervakjes; het aantal
                          staat nu naast het kopje. */}
                      <div style={{ "flex": "0 0 auto" }}>
                        <div style={{ "fontSize": "14px", "fontWeight": "700", "marginBottom": "9px" }}>
                          Krabbels
                        </div>
                        {v.showProfileDrawings ? (<>
                          <div style={css(v.profileDrawingsRowStyle)}>
                            {toList(v.profileDrawings).map((d, $index) => (
                              <React.Fragment key={$index}>
                                <button onClick={d?.onOpen} title={d?.title} className="gp-mini" style={css(d?.style)} />
                              </React.Fragment>
                            ))}
                          </div>
                        </>) : (
                          <div style={css(v.geenBadgesStyle)}>
                            <Interp v={v.profileDrawingsEmpty} />
                          </div>
                        )}
                      </div>
                      {' '}
                      <div style={{ "flex": "0 0 auto" }}>
                        {' '}
                        <div style={{ "display": "flex", "alignItems": "baseline", "justifyContent": "space-between", "marginBottom": "9px" }}>
                          <div style={{ "fontSize": "14px", "fontWeight": "700" }}>
                            Badges
                          </div>
                          <div style={{ "fontSize": "12px", "fontWeight": "700", "color": "var(--tekst-3)" }}>
                            <Interp v={v.badgeScore} />
                          </div>
                        </div>
                        {' '}
                        {v.heeftBadges ? null : (
                          <div style={css(v.geenBadgesStyle)}><Interp v={v.geenBadgesTekst} /></div>
                        )}
                        <div style={css(v.profileBadgesRowStyle)}>
                          {toList(v.profileBadges).map((b, $index) => (
                            <React.Fragment key={$index}>
                              <div title={b?.titel} style={css(b?.tileStyle)}>
                                {' '}
                                {b?.hasIcon ? (<>
                                  {' '}
                                  <svg width="19" height="19" viewBox="0 0 24 24" fill={b?.iconFill} stroke={b?.iconStroke} strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                                    <path d={b?.path} />
                                  </svg>
                                  {' '}
                                </>) : null}
                                {' '}
                                {b?.hasText ? (<>
                                  {' '}
                                  <span style={css(b?.textStyle)}>
                                    <Interp v={b?.text} />
                                  </span>
                                  {' '}
                                </>) : null}
                                {' '}
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                        {' '}
                      </div>
                      {' '}
                      <div style={{ "display": "flex", "gap": "8px", "flexWrap": "wrap", "flex": "0 0 auto", "marginTop": "auto", "paddingTop": "4px" }}>
                        {v.showProfileRequest ? (<>
                          <button onClick={v.profileAskRequest} className="gp-btn p" style={{ "position": "relative", "zIndex": "1", "flex": "1 1 0", "minWidth": "0", "justifyContent": "center", "height": "44px", "padding": "0 15px 0 13px", "gap": "8px" }}>
                            {' '}
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.9" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="2" y="4" width="20" height="16" rx="3" />
                              <path d="m3 7 9 6 9-6" />
                            </svg>
                            {"\n                    Stuur een verzoekje\n                  "}
                          </button>
                        </>) : null}
                        {v.showProfileClaim ? (<>
                          <button onClick={v.profileClaim} className="gp-btn" style={css(v.profileClaimStyle)}>
                            Dit ben ik
                          </button>
                        </>) : null}
                        {v.showProfileLogout ? (<>
                          <button onClick={v.confirmLogout} className="gp-btn" style={{ "position": "relative", "zIndex": "1", "flex": "1 1 0", "minWidth": "0", "justifyContent": "center", "height": "44px", "padding": "0 15px" }}>
                            Uitloggen
                          </button>
                        </>) : null}
                      </div>
                      {' '}
                    </div>
                    {' '}
                  </>) : null}
                  {' '}
                  {v.showAccountList ? (<>
                    {' '}
                    {v.accountsMissing ? (<>
                      {' '}
                      <div style={{ "border": "3px solid var(--roze-vlak)", "background": "var(--roze-vlak)", "borderRadius": "12px", "padding": "14px", "fontSize": "13px", "lineHeight": "1.4", "color": "var(--ink)" }}>
                        {"\n              De collectie "}
                        <strong>
                          paal_accounts
                        </strong>
                        {" bestaat nog niet op de server.\n            "}
                      </div>
                      {' '}
                    </>) : null}
                    {' '}
                    {v.accountsEmpty ? (<>
                      {' '}
                      <div style={{ "border": "3px dashed var(--rand-stippel)", "borderRadius": "12px", "padding": "22px 14px", "textAlign": "center", "color": "var(--tekst-3)", "fontSize": "13px" }}>
                        Nog geen accounts.
                      </div>
                      {' '}
                    </>) : null}
                    {' '}
                    {v.showNewAccountBtn ? (<>
                      {/* De enige andere uitweg: zelf een plekje maken. */}
                      <button onClick={v.openAccountEditor} className="gp-btn pink" style={css(v.newAccountStyle)}>
                        <Interp v={v.newAccountLabel} />
                      </button>
                    </>) : null}
                    {' '}
                    <div ref={v.accListRef} style={css(v.accountListStyle)}>
                      {' '}
                      {toList(v.accountList).map((a, $index) => (
                        <React.Fragment key={$index}>
                          {' '}
                          <button onClick={a?.onRowClick} className="gp-btn" title={a?.rowTitle} style={css(a?.rowStyle)}>
                            {' '}
                            <img alt="" src={a?.avatarUrl} style={{ "width": "32px", "height": "32px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                            {' '}
                            <span style={{ "display": "flex", "flexDirection": "column", "gap": "1px", "minWidth": "0", "flex": "1 1 auto" }}>
                              <span style={css(a?.nameStyle)}>
                                <Interp v={a?.name} />
                              </span>
                              <span style={css(a?.whenStyle)}>
                                <Interp v={a?.whenLabel} />
                              </span>
                            </span>
                            {' '}
                            {a?.hasStreak ? (<>
                              {' '}
                              <span title={a?.streakTitle} style={{ "display": "flex", "alignItems": "center", "gap": "2px", "flex": "0 0 auto", "fontSize": "12px", "fontWeight": "700", "color": "var(--oranje-ink)" }}>
                                🔥
                                <Interp v={a?.streakCount} />
                              </span>
                              {' '}
                            </>) : null}
                            {' '}
                            <span style={css(a?.dotStyle)} />
                            {' '}
                          </button>
                          {' '}
                        </React.Fragment>
                      ))}
                      {' '}
                    </div>
                    {' '}
                  </>) : null}
                  {' '}
                </div>
                {' '}
              </>) : null}
              {' '}
            </div>
            {' '}
            {' '}
            {v.showAccountEditor ? (<>
              {' '}
              <div style={css(v.saveBarStyle)}>
                {' '}
                <button onClick={v.saveAccount} className="gp-btn pink" disabled={v.savingAccount} style={{ "flex": "1 1 auto", "justifyContent": "center" }}>
                  <Interp v={v.saveAccountLabel} />
                </button>
                {' '}
              </div>
              {' '}
            </>) : null}
            {' '}
          </div>
          {' '}
        </div>
        {' '}
      </div>
      {' '}
    </>
  );
}
